import React from 'react';
import PropTypes from 'prop-types';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import styles from './index.css';
import TopicSlide from './topicSlide';
import TopicReview from './topicReview';
import TopicTitle from '../../components/topicTitle';
import Recommend from './recommend';
import PointView from './pointView';
import TopicComment from './topicComment';
import { getCommentCounts } from '../../../../services/api';

class Modules extends React.PureComponent {
    static propTypes = {
        docData: PropTypes.object,
        content: PropTypes.array,
        ad: PropTypes.object,
    };

    state = {
        count: [],
    };

    async componentDidMount() {
        const { content } = this.props;
        let columnData = [
            ...content.filter(item => item.type === 'column' && item.display === 1 && item.data.length > 0),
        ];

        columnData = columnData.length > 0 ? columnData[0] : { data: [] };

        const countArr = [];

        for (let i = 0; i < columnData.data.length; i++) {
            const urlArr = columnData.data[i].articleList.map(item => item.commentUrl);
            const count = await getCommentCounts(urlArr);

            countArr.push(count);
        }

        this.setState({ count: countArr });
    }

    getModule(content) {
        const { count } = this.state;
        const {
            docData: { title, slideDisplay, commentUrl, skey, pcUrl },
            ad: { slideAd, infoAd, titleAd1, titleAd2, titleAd3, titleAd4, columnAd1, columnAd2, columnAd3 },
        } = this.props;

        const titleAdArr = [titleAd1, titleAd2, titleAd3, titleAd4];
        const columnAdArr = [columnAd1, columnAd2, columnAd3];

        return content.map(item => {
            const titleAd = titleAdArr[item.moduleIndex - 1];
            const columnAd = columnAdArr[item.moduleIndex - 1];

            if (item.type === 'slide' && slideDisplay === 1 && item.data.length > 0) {
                return <TopicSlide key={item.id} content={item} slideAd={slideAd} />;
            }

            if (item.type === 'review' && item.display === 1 && item.data.length > 0) {
                return (
                    <React.Fragment key={item.id}>
                        <TopicReview content={item} titleAd={titleAd} />
                        {columnAd ? <Ad content={columnAd} /> : ''}
                    </React.Fragment>
                );
            }

            if (item.type === 'column' && item.display === 1 && item.data.length > 0) {
                return (
                    <div className={styles.topic_column} key={item.id}>
                        {item.data.map((col, index) => (
                            <React.Fragment key={index}>
                                <TopicTitle
                                    id={item.specialId}
                                    moduleIndex={col.moduleIndex}
                                    title={col.columnName}
                                    titleAd={titleAdArr[col.moduleIndex - 1]}
                                />
                                {index === 0 ? (
                                    <Recommend
                                        data={col.articleList}
                                        count={count[index] ? count[index] : []}
                                        infoAd={infoAd}
                                    />
                                ) : (
                                    <Recommend data={col.articleList} count={count[index] ? count[index] : []} />
                                )}
                                {columnAdArr[col.moduleIndex - 1] ? (
                                    <Ad content={columnAdArr[col.moduleIndex - 1]} />
                                ) : (
                                    ''
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                );
            }

            if (item.type === 'point' && item.display === 1 && item.data.length > 0) {
                return (
                    <React.Fragment key={item.id}>
                        <PointView content={item} titleAd={titleAd} />
                        {columnAd ? <Ad content={columnAd} /> : ''}
                    </React.Fragment>
                );
            }

            if (item.type === 'comment' && item.display === 1) {
                return (
                    <React.Fragment key={item.id}>
                        <TopicComment
                            content={item}
                            docTitle={title}
                            commentUrl={commentUrl}
                            pcUrl={pcUrl}
                            skey={skey}
                            titleAd={titleAd}
                        />
                        {columnAd ? <Ad content={columnAd} /> : ''}
                    </React.Fragment>
                );
            }

            return '';
        });
    }

    render() {
        const { content } = this.props;

        return <div className={styles.modules}>{this.getModule(content)}</div>;
    }
}

export default errorBoundary(Modules);
